import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

export const BlockWrapper = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => !['withShadow'].includes(prop),
  })
  .attrs(() => ({
    display: 'block',
  }))`
    ${({ withShadow, theme }) =>
      withShadow
        ? `box-shadow: 0 6px 6px -6px ${theme.themeVariables.frameDropShadow};`
        : null};

    &:empty {
      ${({ $emptyStyle }) => $emptyStyle}
    }
  `;

// The Ids defined here are "default" ones used in the default zone mappings
// of our templates. You are free to use only the component and assign it a
// different id if you have particular needs.
export const BLOCKS = {
  appHeader: {
    id: 'block-app-header',
    component: lazy(
      () =>
        import(
          'hb-react/frontoffice/components/BlocksRenderer/blocks/AppHeader'
        ),
    ),
  },
  headerControls: {
    id: 'block-header-controls',
    component: lazy(
      () =>
        import(
          'hb-react/frontoffice/components/BlocksRenderer/blocks/HeaderControls'
        ),
    ),
  },
  filters: {
    id: 'block-filters', // Keep in sync with BlockItems defaultProps
    component: lazy(
      () =>
        import('hb-react/frontoffice/components/BlocksRenderer/blocks/Filters'),
    ),
  },
  tags: {
    id: 'block-tags', // Keep in sync with BlockItems defaultProps
    component: lazy(
      () =>
        import('hb-react/frontoffice/components/BlocksRenderer/blocks/Tags'),
    ),
  },
  items: {
    id: 'block-items',
    component: lazy(
      () =>
        import('hb-react/frontoffice/components/BlocksRenderer/blocks/Items'),
    ),
  },
  emptyContent: {
    id: 'block-empty-content',
    component: lazy(
      () =>
        import(
          'hb-react/frontoffice/components/BlocksRenderer/blocks/EmptyContent'
        ),
    ),
  },
  conditionalBlock: {
    id: 'block-conditional',
    component: lazy(
      () =>
        import(
          'hb-react/frontoffice/components/BlocksRenderer/blocks/ConditionalBlock'
        ),
    ),
  },
  details: {
    id: 'block-details',
    component: lazy(
      () =>
        import('hb-react/frontoffice/components/BlocksRenderer/blocks/Details'),
    ),
  },
  slider: {
    id: 'block-slider',
    component: lazy(
      () =>
        import('hb-react/frontoffice/components/BlocksRenderer/blocks/Slider'),
    ),
  },
  outlet: {
    id: 'outlet',
    component: Outlet,
  },
  side: {
    id: 'block-side',
    component: lazy(
      () =>
        import('hb-react/frontoffice/components/BlocksRenderer/blocks/Side'),
    ),
  },
  spacer: {
    id: 'spacer',
    component: lazy(
      () =>
        import('hb-react/frontoffice/components/BlocksRenderer/blocks/Spacer'),
    ),
  },
  notAuthorized: {
    id: 'not-authorized',
    component: lazy(
      () =>
        import(
          'hb-react/frontoffice/components/BlocksRenderer/blocks/NotAuthorized'
        ),
    ),
  },
};
